import { useSelector } from 'react-redux';

import AddressForm from 'common/components/address/AddressForm';

import AddressPicker from './AddressPicker';

const BillAddressPickupLoggedIn = (props) => {
  const {
    handleAddressChange,
    handleSaveAddress,
    object,
    changeFunction,
    isSaveAddress,
    customer
  } = props;

  const customerAddressReducer = useSelector((state) => state.customerAddress);
  const settingReducer = useSelector((state) => state.setting);

  return (
    <>
      {customer && (
        <AddressPicker
          customerAddresses={customerAddressReducer.data}
          onAddressChange={handleAddressChange}
        />
      )}
      <AddressForm
        object={object}
        changeFunction={changeFunction}
        settings={settingReducer}
      />
      {customer && (
        <div>
          <label htmlFor="saveAddress">
            <input
              type="checkbox"
              name="saveAddress"
              onChange={handleSaveAddress}
              value
              checked={isSaveAddress}
            />
            Save this information
          </label>
        </div>
      )}
    </>
  );
};

export default BillAddressPickupLoggedIn;
